import PropTypes from 'prop-types';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Alert from 'client/components/ui/Alert/Alert';
import Dialog from 'client/components/aria/Dialog/Dialog';
import Button from 'client/components/aria/Button/Button';
import Select from 'client/components/GDS/Select/Select';

import styles from './OrganisationModal.module.scss';

export const OrganisationModal = ({ open, handleCancel, currentOrganisationId, organisations, setOrganisationId, cancelButtonI18nKey }) => {
    const UNDEFINED_ORG = '';
    const [chosenOrganisationId, setChosenOrganisationId] = useState(currentOrganisationId || UNDEFINED_ORG);
    const intl = useIntl();

    if (!organisations || organisations.length === 0) {
        return <></>;
    }

    const handleSave = () => {
        setOrganisationId(chosenOrganisationId);
    };
    const handleChangeSelect = (e) => {
        setChosenOrganisationId(e.target.value);
    };

    const saveDialogActions = (
        <div className={styles.actions}>
            <Button
                data-testid="organisationModal.button.cancel"
                variant="error"
                onPress={handleCancel}
            >
                <FormattedMessage id={cancelButtonI18nKey} />
            </Button>
            <Button
                data-testid="organisationModal.button.save"
                variant="success"
                onPress={handleSave}
                isDisabled={!chosenOrganisationId}
            >
                <FormattedMessage id='organisationModal.continueButtonLabel' />
            </Button>
        </div>
    );

    return <Dialog
        data-testid="organisationModal.dialog"
        role={'alertdialog'}
        aria-labelledby="organisation.dialog.title"
        isOpen={open}
    >
        <Alert data-testid="organisationModal.dialog.alert" role="document">
            <h1 className="govuk-label-wrapper" id="organisation.dialog.title">
                <label className="govuk-label govuk-label--l">
                    <FormattedMessage id='organisationModal.title' />
                </label>
            </h1>
            <div className='govuk-form-group'>
                <div className="govuk-hint">
                    <FormattedMessage id='organisationModal.message'/>
                </div>
                <Select
                    name='organisation'
                    data-testid='organisationModal.selectBox'
                    value={chosenOrganisationId}
                    onChange={handleChangeSelect}
                    label={intl.formatMessage({ id: 'organisationModal.choiceLabel' })}>
                    <option value={UNDEFINED_ORG} data-testid={'organisationModal.optionChoose'}>{intl.formatMessage({ id: 'organisationModal.chooseOption' })}</option>
                    {organisations.map(org => <option data-testid={`organisationModal.option${org.organisationId}`} key={org.organisationId} value={org.organisationId}>{org.displayName}</option>)}
                </Select>
                {saveDialogActions}
            </div>
        </Alert>
    </Dialog>;
};

OrganisationModal.propTypes = {
    setOrganisationId: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired,
    organisations: PropTypes.arrayOf(PropTypes.shape({
        organisationId: PropTypes.string.isRequired,
        displayName: PropTypes.string.isRequired
    })).isRequired,
    cancelButtonI18nKey: PropTypes.string,
    currentOrganisationId: PropTypes.string,
    open: PropTypes.bool
};

OrganisationModal.defaultProps = {
    cancelButtonI18nKey: 'general.cancel',
    currentOrganisationId: '',
    open: false
};
